import Match from "@/models/Match";
import User from "@/models/User";

const user = {
    id: null,
    user: User,
    status: null,
    amount: 0,
    payment_method: 'bonifico',
    details: [],
    match: Match,
};

export default user
